import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { IconContext } from 'react-icons';
import { Toaster } from './ui';
import NotFoundPage from './pages/notFound/NotFoundPage';
import UserRoutes from './routes/userRoutes';
import AdminRoutes from './routes/adminRoutes';
import ProtectedRoute from './configs/protectedRoutes';
import AuthPage from './pages/auth/authPage';
import ErrorBoundary from './components/ErrorBoundary';

// Every react-icons icon gets the .ui-icon class (inline alignment, see components.css)
const iconContext = { className: 'ui-icon' };

function App() {
  return (
    <ErrorBoundary>
      <IconContext.Provider value={iconContext}>
        <Toaster />
        <Router>
          <Routes>
            {/* Public auth route */}
            <Route path="/auth" element={<AuthPage />} />

            {/* Admin routes (fully protected) */}
            <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
              <Route path="/admin/*" element={<AdminRoutes />} />
            </Route>

            {/* User routes (public + protected combined inside) - Must be last */}
            <Route path="*" element={<UserRoutes />} />
          </Routes>
        </Router>
      </IconContext.Provider>
    </ErrorBoundary>
  );
}

export default App;
